/**
 * Hosts that may show the Transpond LoadingIconFull boot/bundle loader.
 * Agency white-labels keep the legacy sk-chase spinner.
 * Keep in sync with public/js/loadingIconFullBoot.js
 *
 * @param {string} [host] window.location.host
 * @returns {boolean}
 */
function isTranspondBootLoaderHost(host) {
    const h = String(host || '')
        .toLowerCase()
        .split('/')[0]
    if (!h) return false
    if (h === 'localhost' || h.indexOf('localhost:') === 0) return true
    if (h.indexOf('127.0.0.1') === 0) return true
    if (/:(8080|8082)$/.test(h)) return true
    if (h === 'app.transpond.io') return true
    if (h.indexOf('.mpztesting.com') !== -1 || h === 'mpztesting.com') return true
    if (h.indexOf('test.web.') === 0) return true
    if (h.indexOf('dev.web.') === 0) return true
    if (h.indexOf('amplifyapp.com') !== -1) return true
    return false
}

module.exports = {
    isTranspondBootLoaderHost
}
